import {useLocation, useNavigate} from 'react-router-dom'
import {useState} from 'react'
import clsx from 'clsx'
import useUtils from './useUtils'
import back from '../../../_metronic/assets/custom-icons/back.png'
const PreviewProgram = ({className}) => {
  const navigate = useNavigate()
  const {state} = useLocation()
  const {publishProgram, handleEdit} = useUtils()
  const [tab, setTab] = useState(1)
  const [values] = useState(state?.values)

  const bannerImageURL = values?.bannerImage
    ? URL.createObjectURL(values?.bannerImage)
    : values?.bannerImgUrl
    ? values?.bannerImgUrl
    : values?.imgUrl
    ? values?.imgUrl
    : ''

  const submitModule = (id) => {
    publishProgram(id)
  }

  const onClone = async (id2) => {
    const result = await handleEdit(id2)

    const {id, code, title, longDescription, shortDescription, ...newResult} = result
    navigate('/programlist/addProgram', {state: {result: newResult}})
  }

  const onEdit = async (id) => {
    const result = await handleEdit(id)
    navigate('/programlist/editprogram', {state: {result}})
  }
console.log("values",values);

  const Description = () => {
    return (
      <>
        <div className='fs-6'>
          <div className='fw-bold'>Short Description</div>
          <div className='mt-2'>{values.shortDescription}</div>
        </div>
        <div className='fs-6 mt-5'>
          <div className='fw-bold'>Detailed Description</div>
          <div className='mt-2'>{values.longDescription}</div>
        </div>
      </>
    )
  }

  const LearningPoints = () => {
    return (
      <div className='fs-6'>
        <div>
          {' '}
          <ul style={{listStyleType: 'square'}}>
            {values?.learningPoints.map((val, index) => (
              <li key={index} className=''>
                <div>{val}</div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    )
  }

  const Courses = () => {
    return (
      <div className='fs-6'>
        <div>
          {' '}
          <ul style={{listStyleType: 'square'}}>
            {values?.courses.map((val, index) => (
              <li key={index} className=''>
                <div>{val}</div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    )
  }

  return (
    <>
      <div className={`card ${className}`}>
        <img
          onClick={() => navigate(-1)}
          style={{width: '24px', height: '24px', cursor: 'pointer'}}
          src={back}
          className='me-2'
        />
        <div className='pt-4 px-4 mb-3' style={{fontSize: '14px'}}>
          <div className='d-flex justify-content-between'>
            <div className='d-flex align-items-start gap-3 flex-wrap'>
              {bannerImageURL ? (
                <img
                  style={{cursor: 'pointer', width: '400px', height: '200px', objectFit: 'cover'}}
                  src={bannerImageURL}
                  alt='Program Banner'
                />
              ) : (
                <img
                  style={{width: '400px', height: '200px'}}
                  src='https://placehold.co/400x200?text=No+Banner+Image'
                  alt='No Banner'
                />
              )}

              <div className='d-flex flex-column t-14 gap-2 mt-2'>
                <div className='d-flex gap-1'>
                  <div className='fw-bold m-0'>Code:</div>
                  <div>{values?.code}</div>
                </div>
                <div className='d-flex gap-1'>
                  <div className='fw-bold m-0'>Title:</div>
                  <div>{values?.title}</div>
                </div>
                <div className='d-flex gap-1'>
                  <div className='fw-bold m-0'>Author Name:</div>
                  <div>{values?.authorName}</div>
                </div>
                <div className='d-flex gap-1'>
                  <div className='fw-bold m-0'>Language:</div>
                  <div>{values?.language}</div>
                </div>
                <div className='d-flex gap-1'>
                  <div className='fw-bold m-0'>Cohort:</div>
                  <div>{values?.cohorts}</div>
                </div>
                <div className='d-flex gap-1'>
                  <div className='fw-bold m-0'>category:</div>
                  <div>{values?.category}</div>
                </div>
                <div className='d-flex gap-1'>
                  <div className='fw-bold m-0'>Tags:</div>
                  <div>
                    {values?.tags?.map((val, index) =>
                      values?.tags?.length - 1 === index ? val : val + ', '
                    )}
                  </div>
                </div>
                <div className='d-flex gap-1'>
                  <div className='fw-bold m-0'>Status:</div>
                  <div>{values.status || 'drafts'}</div>
                </div>
              </div>
            </div>

            <div>
              <button
                type='button'
                className='btn btn-primary text-nowrap ms-2 mt-2 me-2'
                onClick={() => onClone(values?.id)}
              >
                Clone
              </button>
              <button
                type='button'
                className='btn btn-primary ms-2 mt-2 me-2'
                onClick={() => onEdit(values.id)}
              >
                Edit Program
              </button>
              {values.status !== 'published' && (
                <button
                  type='button'
                  className='btn btn-primary ms-2 mt-2 me-2'
                  onClick={() => submitModule(values.id)}
                >
                  Publish Program
                </button>
              )}
            </div>
          </div>

          <div className='card-header card-header-stretch overflow-auto'>
            <ul
              className='nav nav-stretch nav-line-tabs fw-bold border-transparent flex-nowrap'
              role='tablist'
            >
              <li className='nav-item'>
                <a
                  className={clsx(`nav-link cursor-pointer`, {active: tab === 1})}
                  onClick={() => setTab(1)}
                  role='tab'
                >
                  Descriptions
                </a>
              </li>
              <li className='nav-item'>
                <a
                  className={clsx(`nav-link cursor-pointer`, {active: tab === 2})}
                  onClick={() => setTab(2)}
                  role='tab'
                >
                  What will you learn
                </a>
              </li>
              <li className='nav-item'>
                <a
                  className={clsx(`nav-link cursor-pointer`, {active: tab === 3})}
                  onClick={() => setTab(3)}
                  role='tab'
                >
                  Courses
                </a>
              </li>
            </ul>
          </div>

          <div className='card-body'>
            <div className='tab-content'>
              <div className={clsx('tab-pane', {active: tab === 1})}>
                <Description />
              </div>

              <div className={clsx('tab-pane', {active: tab === 2})}>
                <LearningPoints />
              </div>

              <div className={clsx('tab-pane', {active: tab === 3})}>
                <Courses />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export {PreviewProgram}
